import React from 'react';
import styled from 'styled-components';
import { useI18n } from '@infrastructure/i18n';
import { themeGet } from '@styled-system/theme-get';
import { A, Text, Flex, EmptyView } from '@ui/wrapper';
import { XTS_EMAIL } from '@config/app.constants';
import { BrandProvider } from '@infrastructure/styling/BrandProvider';

const i18ns = {
  tryAgain: 'XSS_TRY_AGAIN',
  error: 'XSS_ERROR_OOPS',
  emailMessage: 'XSS_BRIEFING_DASHBOARD_ERROR_CONTACT',
} as const;

const ErrorWrapper = styled(Flex)`
  position: absolute;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
`;

const EmailLink = styled(A)`
  cursor: pointer;
  margin: auto;
`;

const EmailText = styled(Text)`
  text-align: center;
`;

const EmailFlex = styled(Flex)`
  flex-direction: column;
  margin-top: ${themeGet('space.6')};
`;

const Error = () => {
  const { i18n } = useI18n<typeof i18ns>();

  return (
    <BrandProvider>
      <ErrorWrapper
        justifyContent="center"
        alignItems="center"
        data-testid="error-page"
      >
        <EmptyView>
          <EmptyView.Icon name="CoreWarning" />
          <EmptyView.Headline>{i18n(i18ns.error)}</EmptyView.Headline>
          <EmptyView.ReloadButton>
            {i18n(i18ns.tryAgain)}
          </EmptyView.ReloadButton>
          <EmailFlex>
            <EmailText>{i18n(i18ns.emailMessage)}</EmailText>
            <EmailLink data-testid="email-link" href={`mailto:${XTS_EMAIL}`}>
              {XTS_EMAIL}
            </EmailLink>
          </EmailFlex>
        </EmptyView>
      </ErrorWrapper>{' '}
    </BrandProvider>
  );
};

export { Error };
